<div v-if="!loading && profileLoaded && currentProfile">
  <HomeNavBar
    ref="homeNavBarRef"
    @active-profile-loaded="active_profile = $event"
    @profile_updated="onProfileUpdated"
    @questions_fetched="questions = $event"
    @business_profile_created="get_created_business"
    @location_selected="onLocationSelected"
  />
  <!-- <div v-if="profileLoaded"> -->
  <div v-if="isBusinessProfile" class="scrollable-container">
    <BusinessProfile
      ref="businessProfileRef"
      @edit_business_profile="on_edit_buainess_profile"
      :active_user_profile="active_user_profile"
      :active_profile_data="active_profile"
      :questions="questions"
      @company_profile_updated="onProfileUpdated"
      @cart_updated="on_cart_updated"
    />
  </div>
  <div v-else-if="isPersonalProfile" class="scrollable-container mb-5">
    <CustomerProfileView
      ref="customerProfileRef"
      :selected-location="selectedLocation"
      @customer_profile_updated="onProfileUpdated"
      :active_profile_data="active_profile"
    />
  </div>
  <InactivityModal />
  <!-- </div> -->
</div>
